/** 1 -> 2: give every player the seven-day townless countdown.
 *
 * `PlayerState.townlessDays` is the classic's grace period made into stored data: a
 * player who loses his last town has seven days to take another, and the day
 * boundary needs somewhere to write down how many of them have gone. A save
 * written before the field existed has players who hold towns and players who
 * do not, and nothing anywhere in it that says how long the second kind have
 * been homeless - the state carries no history to reconstruct it from.
 *
 * Zero is therefore the only honest value, and it is also the generous one: a
 * townless player loaded out of an old save gets his seven days back rather
 * than being eliminated on the first day boundary after the load. Erring the
 * other way would end somebody's game as a side effect of opening a file.
 *
 * This is also the template for a nested-field rung, which is why it is three
 * lines long: read the envelope, rewrite the entity map, re-stamp.
 */

import type { Migration } from "./types.js";
import { addFieldToEntities, readSave, writeSave } from "./tree.js";

export const migration0002: Migration = {
  from: 1,
  to: 2,
  describe: "give every player the seven-day townless countdown",
  migrate(raw: unknown): Record<string, unknown> | null {
    const save = readSave(raw);
    if (save === null) return null;
    const state = addFieldToEntities(save.state, "players", "townlessDays", 0);
    if (state === null) return null;
    return writeSave(save, state, 2);
  },
};
